var path = 'admin/templates/partials/menu.html';
var html = "<ul class=\"tabs\">\n  <li class=\"tab{{ menu_tab == 'clinic_list'? ' active': '' }}\">\n    <a href=\"/admin/clinic/list\" target=\"_self\">Clinic List</a>\n  </li>\n  <li class=\"tab{{ menu_tab == 'clinic'? ' active': '' }}\">\n    <a href=\"/admin/clinic\" target=\"_self\">Add/Edit Clinic</a>\n  </li>\n  <li class=\"tab{{ menu_tab == 'pharmacist'? ' active': '' }}\">\n    <a href=\"/admin/pharmacist\">Pharmacists</a>\n  </li>\n  <li class=\"tab{{ menu_tab == 'referral'? ' active': '' }}\">\n    <a href=\"/admin/referral\">Referrals</a>\n  </li>\n  <li class=\"tab{{ menu_tab == 'user'? ' active': '' }}\">\n    <a href=\"/admin/user\">Users</a>\n  </li>\n</ul>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/admin/templates/partials/menu.html
 ** module id = 137
 ** module chunks = 0
 **/